import { useContext } from 'react'
import cx from 'classnames'
import { Link } from 'react-router'

import {
  heroIconButtonVariantClasses,
  iconButtonVariantClasses,
  tableIconButtonVariantClasses,
} from './Button/buttonStyles'
import { IconButtonToneContext } from './contexts'

const getAccessibleLabel = (componentName, label, title) => {
  const accessibleLabel = label || title
  if (process.env.NODE_ENV !== 'production' && !accessibleLabel) {
    // eslint-disable-next-line no-console
    console.warn(`${componentName} requires a label or title for its accessible name.`)
  }

  return accessibleLabel
}

export const IconButton = ({ children, className, label, title, variant = 'ghost', ...props }) => {
  const tone = useContext(IconButtonToneContext)
  const accessibleLabel = getAccessibleLabel('IconButton', label, title)
  const variantClasses = tone === 'table'
    ? tableIconButtonVariantClasses[variant] || tableIconButtonVariantClasses.ghost
    : tone === 'hero'
      ? heroIconButtonVariantClasses[variant] || heroIconButtonVariantClasses.ghost
      : iconButtonVariantClasses[variant] || iconButtonVariantClasses.ghost

  return (
    <button
      aria-label={accessibleLabel}
      className={cx(
        'ds-icon-button tw:inline-flex tw:h-10 tw:w-10 tw:items-center tw:justify-center tw:rounded-button tw:border',
        'tw:transition-colors tw:duration-fast tw:ease-standard',
        variantClasses,
        className,
      )}
      data-tone={tone}
      data-variant={variant}
      title={title}
      type="button"
      {...props}
    >
      {children}
    </button>
  )
}

export const IconButtonLink = ({ children, className, href, label, title, to, variant = 'ghost', ...props }) => {
  const tone = useContext(IconButtonToneContext)
  const accessibleLabel = getAccessibleLabel('IconButtonLink', label, title)
  const variantClasses = tone === 'table'
    ? tableIconButtonVariantClasses[variant] || tableIconButtonVariantClasses.ghost
    : tone === 'hero'
      ? heroIconButtonVariantClasses[variant] || heroIconButtonVariantClasses.ghost
      : iconButtonVariantClasses[variant] || iconButtonVariantClasses.ghost

  const Component = href ? 'a' : Link

  return (
    <Component
      aria-label={accessibleLabel}
      className={cx(
        'ds-icon-button tw:inline-flex tw:h-10 tw:w-10 tw:items-center tw:justify-center tw:rounded-button tw:border',
        'tw:transition-colors tw:duration-fast tw:ease-standard',
        variantClasses,
        className,
      )}
      data-tone={tone}
      data-variant={variant}
      href={href}
      title={title}
      to={href ? undefined : to}
      {...props}
    >
      {children}
    </Component>
  )
}
